import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accesos-filtros-busqueda',
  templateUrl: './accesos-filtros-busqueda.component.html',
  styleUrls: ['./accesos-filtros-busqueda.component.css']
})
export class AccesosFiltrosBusquedaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
